import React, { useState, useEffect } from "react";
import { collection, getDoc, getFirestore, doc, getDocs, updateDoc, arrayUnion, arrayRemove, query, where } from "firebase/firestore";
import { app } from '../../credenciales';
import { Button, Table, Container, Row, Col } from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import style from "./Actividades.module.css";
import ActivityFormModal from "../../components/Modals/ActivityFormModal";
import { FaAnglesRight, FaUserPlus, FaAnglesLeft, FaUserMinus, FaPen, FaCalendarDays } from "react-icons/fa6";
import { getActivityData, getUsers, getUsersByActivity, updateActivityUsersDates, updateUserActivity } from "../../utils/Data";

const db = getFirestore(app);

const ActivityPage = () => {
  const { idActividad } = useParams();
  const [activityData, setActivityData] = useState("");
  const [usuariosDisponibles, setUsuariosDisponibles] = useState([]);
  const [usuariosEnActividad, setUsuariosEnActividad] = useState([]);
  const [selectedLeft, setSelectedLeft] = useState([]);
  const [selectedRight, setSelectedRight] = useState([]);
  const [showEditModal, setShowEditModal] = useState(false);
  const [profesoresDisponibles, setProfesoresDisponibles] = useState([]);
  const [profesoresEnActividad, setProfesoresEnActividad] = useState([]);
  const [selectedLeftProf, setSelectedLeftProf] = useState([]);
  const [selectedRightProf, setSelectedRightProf] = useState([]);

  const navigate = useNavigate();

  const handleCloseEditModal = () => setShowEditModal(false);
  const handleShowEditModal = () => setShowEditModal(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const actividadSnap = await getActivityData(idActividad);

        if (actividadSnap.exists()) {
          setActivityData(actividadSnap.data());
        }

        const usersSnapshot = await getUsers();
        const allUsers = usersSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

        const alumnos = allUsers.filter(user => user.role === "2" || user.role === "3");
        const profesores = allUsers.filter(user => user.role === "3");

        const usersInActivity = await getUsersByActivity(idActividad);
        const listOfUsersInActivity = usersInActivity.docs.map(doc => ({ id: doc.id, ...doc.data() })).filter(user => user.role !== "1");
        setUsuariosEnActividad(listOfUsersInActivity);

        const fechas = actividadSnap.data().fechas || [];
        const profesoresIdsSet = new Set();

        fechas.forEach(fecha => {
          (fecha.profesores || []).forEach(prof => profesoresIdsSet.add(prof.id));
        });

        const profesoresEnActividadList = allUsers.filter(user => profesoresIdsSet.has(user.id));
        setProfesoresEnActividad(profesoresEnActividadList);

        const idsEnActividad = new Set([
          ...listOfUsersInActivity.map(u => u.id),
          ...profesoresEnActividadList.map(p => p.id)
        ]);

        const alumnosNoEnActividad = alumnos.filter(user => !idsEnActividad.has(user.id));
        const profesoresNoEnActividad = profesores.filter(user => !idsEnActividad.has(user.id));

        setUsuariosDisponibles(alumnosNoEnActividad);
        setProfesoresDisponibles(profesoresNoEnActividad);
      } catch (error) {
        console.error("Error al cargar datos:", error);
      }
    };

    fetchData();
  }, [idActividad, showEditModal, usuariosDisponibles, usuariosEnActividad, profesoresDisponibles, profesoresEnActividad]);

  const transferAlumnos = async (source, setSource, target, setTarget, usersToMove, action) => {
    if (usersToMove.length === 0) return;

    try {
      const activitySnap = await getActivityData(idActividad);

      if (!activitySnap.exists()) return;

      const activityData = activitySnap.data();
      const updatedDates = activityData.fechas.map((fecha) => {
        const usuarios = fecha.usuarios || [];

        if (action === "add") {
          const nuevosUsuarios = usersToMove
            .filter(id => !usuarios.some(usuario => usuario.id === id))
            .map(id => ({ id, presente: false, ausenteConAviso: false }));
          return { ...fecha, usuarios: [...usuarios, ...nuevosUsuarios] };
        }

        if (action === "remove") {
          return { ...fecha, usuarios: usuarios.filter(usuario => !usersToMove.includes(usuario.id)) };
        }

        return fecha;
      });

      await updateActivityUsersDates(updatedDates, idActividad);

      for (const userId of usersToMove) {
        if (action === "add") {
          await updateUserActivity(userId, idActividad, 'add');
        } else if (action === "remove") {
          await updateUserActivity(userId, idActividad, 'remove');
        }
      }

      setSource(source.filter(user => !usersToMove.includes(user.id)));
      setTarget([...target, ...source.filter(user => usersToMove.includes(user.id))]);
    } catch (error) {
      console.error("Error al actualizar alumnos:", error);
    }
  };
  /// A PARTIR DE ACÁ SEGUIR
  const transferProfesores = async (source, setSource, target, setTarget, usersToMove, action) => {
    try {
      const actividadRef = doc(db, "actividades", idActividad);
      const actividadSnap = await getDoc(actividadRef);
      if (!actividadSnap.exists()) return;

      const actividadData = actividadSnap.data();
      const updatedFechas = actividadData.fechas.map((fecha) => {
        const profesores = fecha.profesores || [];

        if (action === "add") {
          const nuevosProfesores = usersToMove
            .filter(id => !profesores.some(p => p.id === id))
            .map(id => ({ id, presente: false, ausenteConAviso: false }));
          return { ...fecha, profesores: [...profesores, ...nuevosProfesores] };
        }

        if (action === "remove") {
          return { ...fecha, profesores: profesores.filter(p => !usersToMove.includes(p.id)) };
        }

        return fecha;
      });

      await updateDoc(actividadRef, { fechas: updatedFechas });

      setSource(source.filter(user => !usersToMove.includes(user.id)));
      setTarget([...target, ...source.filter(user => usersToMove.includes(user.id))]);
    } catch (error) {
      console.error("Error al actualizar profesores:", error);
    }
  };

  const handleGoToDate = () => {
    navigate(`/fechas/${idActividad}`);
  };

  return (
    <Container className="py-4">
      <h1 className="titles">Actividad {activityData.nombre}</h1>
      <div className={`${style.activityActionsBtnContainer} d-flex`}>
        <Button size="xs" variant="dark" className={`${style.activityBtn} primaryBtn mt-2 d-flex align-items-center`} onClick={handleShowEditModal}><FaPen /> Editar actividad</Button>
        <Button size="xs" variant="dark" className={`${style.activityBtn} primaryBtn mt-2 d-flex align-items-center`} onClick={handleGoToDate}><FaCalendarDays /> Ver fechas de la actividad</Button>
      </div>

      <h2 className="mt-5">Alumnos</h2>
      <Row className="mt-4">
        <Col>
          <h5>Alumnos no inscriptos</h5>
          <select multiple value={selectedLeft} onChange={(e) => setSelectedLeft(Array.from(e.target.selectedOptions, option => option.value))} style={{ width: '100%', height: '180px' }}>
            {usuariosDisponibles.map(user => (
              <option key={user.id} value={user.id}>{user.name} {user.lastName}</option>
            ))}
          </select>
          <Row>
            <Col className={`${style.activityBtnContainer} d-flex`}>
              <Button onClick={() => transferAlumnos(usuariosDisponibles, setUsuariosDisponibles, usuariosEnActividad, setUsuariosEnActividad, selectedLeft, "add")} className={`${style.activityBtn} primaryBtn d-flex align-items-center`}>
                <FaUserPlus /> Agregar
              </Button>
              <Button onClick={() => transferAlumnos(usuariosDisponibles, setUsuariosDisponibles, usuariosEnActividad, setUsuariosEnActividad, usuariosDisponibles.map(u => u.id), "add")} className={`${style.activityBtn} primaryBtn d-flex align-items-center`}>
                <FaAnglesRight /> Agregar Todos
              </Button>
            </Col>
          </Row>
        </Col>

        <Col>
          <h5>Alumnos inscriptos</h5>
          <select multiple value={selectedRight} onChange={(e) => setSelectedRight(Array.from(e.target.selectedOptions, option => option.value))} style={{ width: '100%', height: '180px' }}>
            {usuariosEnActividad.map(user => (
              <option key={user.id} value={user.id}>{user.name} {user.lastName}</option>
            ))}
          </select>
          <Row>
            <Col className={`${style.activityBtnContainer} d-flex`}>
              <Button onClick={() => transferAlumnos(usuariosEnActividad, setUsuariosEnActividad, usuariosDisponibles, setUsuariosDisponibles, selectedRight, "remove")} className={`${style.activityBtn} primaryBtn d-flex align-items-center`}>
                <FaUserMinus /> Quitar
              </Button>
              <Button onClick={() => transferAlumnos(usuariosEnActividad, setUsuariosEnActividad, usuariosDisponibles, setUsuariosDisponibles, usuariosEnActividad.map(u => u.id), "remove")} className={`${style.activityBtn} primaryBtn d-flex align-items-center`}>
                <FaAnglesLeft /> Quitar Todos
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>

      <h2 className="mt-5">Profesores</h2>
      <Row className="mt-3">
        <Col>
          <h5>Profesores no asignados</h5>
          <select multiple value={selectedLeftProf} onChange={(e) => setSelectedLeftProf(Array.from(e.target.selectedOptions, option => option.value))} style={{ width: '100%', height: '180px' }}>
            {profesoresDisponibles.map(user => (
              <option key={user.id} value={user.id}>{user.name} {user.lastName}</option>
            ))}
          </select>
          <Row>
            <Col className={`${style.activityBtnContainer} d-flex`}>
              <Button onClick={() => transferProfesores(profesoresDisponibles, setProfesoresDisponibles, profesoresEnActividad, setProfesoresEnActividad, selectedLeftProf, "add")} className={`${style.activityBtn} primaryBtn d-flex align-items-center`}>
                <FaUserPlus /> Agregar
              </Button>
              <Button onClick={() => transferProfesores(profesoresDisponibles, setProfesoresDisponibles, profesoresEnActividad, setProfesoresEnActividad, profesoresDisponibles.map(u => u.id), "add")} className={`${style.activityBtn} primaryBtn d-flex align-items-center`}>
                <FaAnglesRight /> Agregar Todos
              </Button>
            </Col>
          </Row>
        </Col>

        <Col>
          <h5>Profesores asignados</h5>
          <select multiple value={selectedRightProf} onChange={(e) => setSelectedRightProf(Array.from(e.target.selectedOptions, option => option.value))} style={{ width: '100%', height: '180px' }}>
            {profesoresEnActividad.map(user => (
              <option key={user.id} value={user.id}>{user.name} {user.lastName}</option>
            ))}
          </select>
          <Row>
            <Col className={`${style.activityBtnContainer} d-flex`}>
              <Button onClick={() => transferProfesores(profesoresEnActividad, setProfesoresEnActividad, profesoresDisponibles, setProfesoresDisponibles, selectedRightProf, "remove")} className={`${style.activityBtn} primaryBtn d-flex align-items-center`}>
                <FaUserMinus /> Quitar
              </Button>
              <Button onClick={() => transferProfesores(profesoresEnActividad, setProfesoresEnActividad, profesoresDisponibles, setProfesoresDisponibles, profesoresEnActividad.map(u => u.id), "remove")} className={`${style.activityBtn} primaryBtn d-flex align-items-center`}>
                <FaAnglesLeft /> Quitar Todos
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>

      <h2 className="mt-4">Alumnos en esta actividad:</h2>
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Apellido</th>
            <th>Correo Electrónico</th>
          </tr>
        </thead>
        <tbody>
          {[...profesoresEnActividad, ...usuariosEnActividad].map((usuario) => (
            <tr key={usuario.id}>
              <td>{usuario.name} {usuario.lastName} {usuario.role === "3" && profesoresEnActividad.some(profesor=>profesor.id === usuario.id) && <strong>(Profesor)</strong>}</td>
              <td>{usuario.lastName}</td>
              <td>{usuario.email}</td>
            </tr>
          ))}
        </tbody>
      </Table>

      <ActivityFormModal showModal={showEditModal} handleCloseModal={handleCloseEditModal} activityIdToEdit={idActividad} edit={true} />
    </Container>
  );
};

export default ActivityPage;
